// @ts-ignore
// import MAT from './MAT.svg'
import BNB from './BNB.svg'
import TOX from './TOX.png'
import TOXA from './TOXA.png'
import TOXB from './TOXB.png'
import GLD from './GLD.png'
import weth from './weth.png'

const ImageToken: any = {
  BNB: BNB,
  WBNB: BNB,
  TOX,
  TOXA,
  TOXB,
  GLD,
  USDT: TOX,
  USDC: TOXB,
  WETH: weth
}
export default ImageToken
